import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { work_process } from "../../../assets/data/work-process";
import { Angle } from "../../../assets/ThemeIcon";
import ShapeMobile4 from "./shapes/ShapeMobile4";
import ShapeMobile5 from "./shapes/ShapeMobile5";
const WorkProcess = () => {
	const [mobileScreen, setMobileScreen] = useState(true);

	const handleMobile = () => {
		const width = window.innerWidth;
		if (width < 991) {
			setMobileScreen(true);
		} else {
			setMobileScreen(false);
		}
	};

	useEffect(() => {
		handleMobile();
		window.addEventListener("resize", handleMobile);
	}, []);
	return (
		<section className="work-process-section">
			{mobileScreen && (
				<>
					<div className="process-shape">
						<ShapeMobile4 />
					</div>
					<div className="process-shape-2">
						<ShapeMobile5 />
					</div>
				</>
			)}
			<div className="container">
				<div className="row g-4">
					{work_process &&
						work_process.map(({ title, text, btn, link }, i) => (
							<div className="col-sm-6 col-xl-3" key={i}>
								<div className="work-process">
									<h4 className="title">
										{i + 1}
										{". "}
										{title}
									</h4>
									<div className="text">{text}</div>
									<Link to={link}>
										{btn} <Angle />{" "}
									</Link>
								</div>
							</div>
						))}
				</div>
			</div>
		</section>
	);
};

export default WorkProcess;
